import React, { useState, useEffect } from 'react';
import { API } from '../config';

export default function NeedList({ needs, currentUser, onRefresh }) {
  const [filter, setFilter] = useState('');
  const [selected, setSelected] = useState(null);
  const [sending, setSending] = useState(false);
  const [liveMatches, setLiveMatches] = useState(null);
  const [pendingReqs, setPendingReqs] = useState([]);

  const filtered = filter ? needs.filter(n => n.category === filter) : needs;

  useEffect(() => {
    if (!selected) { setLiveMatches(null); return; }
    fetch(`${API.apiBase}/api/needs/${selected}/rematch`)
      .then(r => r.json())
      .then(setLiveMatches)
      .catch(() => {});
  }, [selected]);

  useEffect(() => {
    if (!currentUser) return;
    fetch(`${API.apiBase}/api/connect-requests?userId=${currentUser.id}`)
      .then(r => r.json())
      .then(data => setPendingReqs(data.filter(d => d.status === 'pending')))
      .catch(() => {});
  }, [currentUser, needs]);

  async function handleRequestConnect(needId, mateId) {
    if (!currentUser) { alert('请先加入校友会'); return; }
    setSending(true);
    try {
      const r = await fetch(`${API.apiBase}/api/connect-request`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ needId, userId: currentUser.id, toUserId: mateId })
      });
      const data = await r.json();
      if (data.status === 'pending' || data.status === 'already_sent') {
        alert('已发送联系请求，等待对方通过');
        if (onRefresh) onRefresh();
      }
    } catch {}
    setSending(false);
  }

  const categories = [...new Set(needs.map(n => n.category))];

  return (
    <div>
      <div style={{ marginBottom: 10, display: 'flex', gap: 6, flexWrap: 'wrap' }}>
        <button onClick={() => setFilter('')} style={filter === '' ? chipActive : chip}>全部</button>
        {categories.map(c => (
          <button key={c} onClick={() => setFilter(c)} style={filter === c ? chipActive : chip}>{c}</button>
        ))}
      </div>

      {filtered.length === 0 && <div style={{ color: '#999', padding: 20, textAlign: 'center' }}>暂无校友动态</div>}

      {filtered.map(need => {
        const matches = selected === need.id && liveMatches ? liveMatches : need.matches;
        const hasPending = pendingReqs.some(r => r.needId === need.id || r.needId === need.id);
        return (
          <div key={need.id} style={{ padding: '10px 12px', marginBottom: 6, border: '1px solid #eee', borderRadius: 8, cursor: 'pointer', background: selected === need.id ? '#fce4ec' : '#fff' }}
            onClick={() => setSelected(selected === need.id ? null : need.id)}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <span style={{ background: '#fce4ec', color: '#e91e63', padding: '1px 8px', borderRadius: 10, fontSize: 12, marginRight: 6 }}>{need.category}</span>
                <strong>{need.title}</strong>
              </div>
              <span style={{ fontSize: 12, padding: '2px 8px', borderRadius: 10, background: '#fff3e0', color: '#e65100' }}>
                寻求中
              </span>
            </div>
            <div style={{ fontSize: 13, color: '#666', marginTop: 4 }}>{need.description}</div>
            <div style={{ fontSize: 12, color: '#999', marginTop: 4 }}>{need.userName} · {new Date(need.createdAt).toLocaleDateString()}</div>

            {hasPending && (
              <div style={{ marginTop: 6, padding: '4px 8px', background: '#e3f2fd', borderRadius: 4, fontSize: 12, color: '#1565c0' }}>
                📩 已发送联系请求
              </div>
            )}

            {selected === need.id && (
              <div style={{ marginTop: 8 }}>
                {matches && matches.length > 0 ? (
                  <div style={{ padding: 8, background: '#fce4ec', borderRadius: 6 }}>
                    <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 4, color: '#e91e63' }}>
                      校友匹配（{matches.length} 位）：
                    </div>
                    {matches.map((m, i) => {
                      const mateId = m.mate?.id || m.id;
                      const alreadySent = pendingReqs.some(r => r.needId === need.id && r.fromUserId === currentUser?.id && r.toUserId === mateId);
                      return (
                        <div key={i} style={{ padding: '6px 0', borderBottom: '1px solid #f8bbd0', fontSize: 13, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <div>
                            <strong>{m.mate?.name || m.name}</strong>
                            <span style={{ marginLeft: 6, color: '#999', fontSize: 12 }}>{m.mate?.schoolName || ''} · {m.mate?.className || ''}</span>
                            <div style={{ color: '#888', fontSize: 12 }}>{m.matchReason || '校友'} · {Math.round((m.score || 0.5) * 100)}%</div>
                          </div>
                          {!alreadySent && currentUser && need.userId !== currentUser.id && (
                            <button onClick={() => handleRequestConnect(need.id, mateId)} disabled={sending}
                              style={{ padding: '4px 12px', border: 'none', borderRadius: 4, background: '#e91e63', color: '#fff', cursor: 'pointer', fontSize: 12 }}>
                              {sending ? '...' : '联系 TA'}
                            </button>
                          )}
                          {alreadySent && (
                            <span style={{ fontSize: 11, color: '#1565c0' }}>已请求</span>
                          )}
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div style={{ padding: 8, background: '#fff3e0', borderRadius: 6, fontSize: 13, color: '#e65100' }}>
                    暂无可推荐的校友
                  </div>
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

const chip = { padding: '4px 12px', border: '1px solid #ddd', borderRadius: 14, background: '#fff', cursor: 'pointer', fontSize: 13, color: '#666' };
const chipActive = { padding: '4px 12px', border: '1px solid #e91e63', borderRadius: 14, background: '#e91e63', cursor: 'pointer', fontSize: 13, color: '#fff' };